import { supabase } from '../lib/supabase';

export const usersService = {
  // Get all users (admin only)
  async getAllUsers() {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.order('created_at', { ascending: false });
    
    if (error) throw error;
    
    // Convert snake_case to camelCase
    return data?.map(user => ({
      id: user?.id,
      email: user?.email,
      fullName: user?.full_name,
      avatarUrl: user?.avatar_url,
      role: user?.role,
      createdAt: user?.created_at,
      updatedAt: user?.updated_at,
      lastLogin: user?.last_login
    })) || [];
  },

  // Update user role (admin only, cannot update own role)
  async updateUserRole(userId, newRole) {
    const { data: { user } } = await supabase?.auth?.getUser();
    
    if (!user) throw new Error('Not authenticated');
    if (user?.id === userId) throw new Error('Cannot update your own role');
    
    const { data, error } = await supabase?.from('user_profiles')?.update({ role: newRole })?.eq('id', userId)?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      role: data?.role,
      updatedAt: data?.updated_at
    };
  },

  // Invite user by email (sends Supabase Auth invitation)
  async inviteUser(email, role, fullName) {
    try {
      // Use Supabase Auth to send invitation email
      // User will set their own password when they accept the invitation
      const { data, error } = await supabase?.auth?.signUp({
        email,
        password: Math.random()?.toString(36)?.slice(2) + Math.random()?.toString(36)?.slice(2) + '!A1', // Random secure password (user will reset)
        options: {
          data: {
            full_name: fullName || email?.split('@')?.[0],
            role: role || 'viewer'
          },
          emailRedirectTo: `${window.location?.origin}/admin-login`
        }
      });
      
      if (error) throw error;
      
      return {
        success: true,
        message: `Invitation sent to ${email}. User will receive a confirmation email to set their password.`,
        userId: data?.user?.id
      };
    } catch (error) {
      throw new Error(error?.message || 'Failed to invite user');
    }
  },

  // Delete user (admin only, cannot delete own account)
  async deleteUser(userId) {
    const { data: { user } } = await supabase?.auth?.getUser();
    
    if (!user) throw new Error('Not authenticated');
    if (user?.id === userId) throw new Error('Cannot delete your own account');
    
    // Delete from user_profiles (RLS policy prevents self-deletion)
    const { error } = await supabase?.from('user_profiles')?.delete()?.eq('id', userId);
    
    if (error) throw error;
    
    return { success: true, message: 'User deleted successfully' };
  }
};